import { useMemo } from 'react';

import { ResponsivePie } from '@nivo/pie';

import themeColors from '../../../../../../assets/styles/themes/default';
import { Container } from './styles';

interface IData {
  label: string;
  value: number;
}
interface PieChartCardProps {
  data: (IData | undefined)[];
  isLoading: boolean;
  isFetching: boolean;
  title: string;
  error: unknown;
}

export const PieChartCard = ({
  data,
  isLoading,
  title,
  error,
  isFetching,
}: PieChartCardProps) => {
  const arrayOfColors = [
    themeColors.colors.orange.primary,
    themeColors.colors.yellow.primary,
    themeColors.colors.attention,
    themeColors.colors.yellow.light,
    themeColors.colors.yellow.pressing,
  ];

  const dataWithColor = useMemo(
    () =>
      data.map((d, index) => ({
        ...d,
        color: arrayOfColors[index],
        id: d?.label,
      })),
    [data]
  );

  return (
    <Container>
      {isLoading || isFetching ? (
        <div>
          <h3>Carregando...</h3>
        </div>
      ) : error ? (
        <div>
          <h3>Falha ao carregar dados.</h3>
        </div>
      ) : (
        <>
          <div className="chart">
            <ResponsivePie
              data={dataWithColor || [{ value: 0, label: '' }]}
              margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
              fit
              activeOuterRadiusOffset={8}
              colors={{ datum: 'data.color' }}
              enableArcLinkLabels={false}
              motionConfig="default"
              arcLabelsSkipAngle={25}
            />
          </div>
          <div className="legendContainer">
            <h3>{title}</h3>
            <div className="lines">
              {dataWithColor?.map((item) => (
                <div className="line" key={Math.random()}>
                  <div style={{ backgroundColor: item.color }} />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </Container>
  );
};
